import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.nvaBrightBlue,
  fontColor: colors.nvaBlack,
  textColorDark: colors.nvaBlack,
  textColorLight: colors.white
};
export default promoBanner;